import Vue from 'vue';

/**
 * Polygons, Markers and Circles are google objects, we use google in those cases as the generic api
 * this *probably* could be improved by using our own classes for those (those classes having a .toGoogle())
 * but they provide no advantage right now.
 */
const pixMapModule = {
  namespaced: true,
  state: {
    maps: {},
    defaultComparableMarker: {}, // object with the default style for a pix comparable marker
    defaultPropertyMarker: {}, // object with the default style for a pix property marker
    defaultPolygonStyle: {
      strokeColor: '#CF0B0D',
      strokeOpacity: 0.8,
      strokeWeight: 2,
      fillColor: '#CF0B0D',
      fillOpacity: 0.15,
      draggable: true,
      editable: true,
      locked: false, // Para indicar si se esta dentro de un estudio
    }, // object with the style for drawn polygons
    defaultCircleStyle: {
      strokeColor: '#CF0B0D',
      strokeOpacity: 0.8,
      strokeWeight: 2,
      fillColor: '#CF0B0D',
      fillOpacity: 0.15,
      draggable: true,
      editable: true,
      locked: false,
    }, // object with the style for drawn polygons
    defaultDataLayerStyle: {
      strokeColor: '#CF0B0D',
      strokeOpacity: 0.8,
      strokeWeight: 2,
      fillColor: '#CF0B0D',
      fillOpacity: 0.15,
    },
    defaultMapsStyle: {},
    maxDataLayerHistoryLength: 5,
  },
  actions: {
    setMap({ commit }, payload) {
      commit('maybeCreateMap', payload);
      commit('setMap', payload);
    },

    deleteMap({ commit }, payload) {
      commit('deleteMap', payload);
    },

    setMarkers({ commit }, payload) {
      commit('maybeCreateMap', payload);
      commit('setMarkers', payload);
    },

    setCircles({ commit }, payload) {
      commit('maybeCreateMap', payload);
      commit('setCircles', payload);
    },

    setPolygons({ commit }, payload) {
      commit('maybeCreateMap', payload);
      commit('setPolygons', payload);
    },

    setDataLayers({ commit }, payload) {
      commit('maybeCreateMap', payload);
      commit('setDataLayers', payload);
    },

    setDrawingMode({ commit }, payload) {
      commit('maybeCreateMap', payload);
      commit('setDrawingMode', payload);
    },

    setMapStyle({ commit }, payload) {
      commit('maybeCreateMap', payload);
      commit('setMapStyle', payload);
    },

    setMapSettings({ commit }, payload) {
      commit('maybeCreateMap', payload);
      commit('setMapSettings', payload);
    },

    setZoom({ commit }, payload) {
      commit('maybeCreateMap', payload);
      commit('setZoom', payload);
    },

    setCenter({ commit }, payload) {
      commit('maybeCreateMap', payload);
      commit('setCenter', payload);
    },

    setActiveMarker({ commit }, payload) {
      commit('maybeCreateMap', payload);
      commit('setActiveMarker', payload);
    },

    setJumpingMarker({ commit }, payload) {
      commit('maybeCreateMap', payload);
      commit('setJumpingMarker', payload);
    },

    setSelectedMarkerInfo({ commit }, payload) {
      commit('maybeCreateMap', payload);
      commit('setSelectedMarkerInfo', payload);
    },

    addDataLayerToHistory({ state, commit }, payload) {
      if (!state.maps[payload.mapId]?.resetDataLayer) {
        commit('setResetDataLayer', payload);
      }
      commit('addDataLayerToHistory', payload);
      commit('setDataLayerHistoryIndex', { ...payload, index: state.maps[payload.mapId]?.dataLayersHistory?.length - 1 });
    },

    clearDataLayersHistory({ state, commit }, payload) {
      commit('setDataLayerHistoryIndex', { ...payload, index: 0 });
      commit('clearDataLayersHistory', payload);
      if (payload.reset) {
        commit('addDataLayerToHistory', { ...payload, dataLayer: state.maps[payload.mapId]?.resetDataLayer });
      } else {
        commit('setResetDataLayer', { ...payload, dataLayer: null });
      }
    },

    setDataLayerHistoryIndex({ commit }, { mapId, index }) {
      commit('setDataLayerHistoryIndex', { mapId, index });
    },
  },
  mutations: {
    maybeCreateMap(state, { mapId }) {
      if (state.maps[mapId]) {
        return;
      }
      Vue.set(state.maps, mapId, {
        map: undefined,
        markers: undefined,
        circles: undefined,
        polygons: undefined,
        dataLayers: undefined,
        drawingMode: undefined,
        mapStyle: undefined,
        mapSettings: undefined,
        zoom: 8,
        center: { lat: 0, lng: 0 },
        activeMarker: undefined,
        markerInfo: undefined,
        jumpingMarker: undefined,
        dataLayersHistory: [],
        dataLayersHistoryIndex: 0,
        resetDataLayer: undefined,
      });
    },

    setMap(state, { mapId, map }) {
      Vue.set(state.maps[mapId], 'map', map);
    },

    deleteMap(state, { mapId }) {
      Vue.delete(state.maps, mapId);
    },

    setMarkers(state, { mapId, markers }) {
      Vue.set(state.maps[mapId], 'markers', markers);
    },

    setCircles(state, { mapId, circles }) {
      Vue.set(state.maps[mapId], 'circles', circles);
    },

    setPolygons(state, { mapId, polygons }) {
      Vue.set(state.maps[mapId], 'polygons', polygons);
    },

    setDataLayers(state, { mapId, dataLayers }) {
      Vue.set(state.maps[mapId], 'dataLayers', dataLayers);
    },

    setDrawingMode(state, { mapId, drawingMode }) {
      Vue.set(state.maps[mapId], 'drawingMode', drawingMode);
    },

    setMapStyle(state, { mapId, mapStyle }) {
      Vue.set(state.maps[mapId], 'mapStyle', mapStyle);
    },

    setMapSettings(state, { mapId, mapSettings }) {
      Vue.set(state.maps[mapId], 'mapSettings', mapSettings);
    },

    setZoom(state, { mapId, zoom }) {
      Vue.set(state.maps[mapId], 'zoom', zoom);
    },

    setCenter(state, { mapId, center }) {
      Vue.set(state.maps[mapId], 'center', center);
    },

    setActiveMarker(state, { mapId, activeMarker }) {
      Vue.set(state.maps[mapId], 'activeMarker', activeMarker);
    },

    setJumpingMarker(state, { mapId, id }) {
      Vue.set(state.maps[mapId], 'jumpingMarker', id);
    },

    setSelectedMarkerInfo(state, { mapId, markerInfo }) {
      Vue.set(state.maps[mapId], 'markerInfo', markerInfo);
    },

    setResetDataLayer(state, { mapId, dataLayer }) {
      Vue.set(state.maps[mapId], 'resetDataLayer', dataLayer);
    },

    addDataLayerToHistory(state, { mapId, dataLayer }) {
      const history = [...state.maps[mapId]?.dataLayersHistory].splice(0, state.maps[mapId]?.dataLayersHistoryIndex + 1);
      history?.push([...dataLayer]);
      if (history?.length > state.maxDataLayerHistoryLength + 1) {
        history.shift();
      }
      Vue.set(state.maps[mapId], 'dataLayersHistory', history);
    },

    clearDataLayersHistory(state, { mapId }) {
      Vue.set(state.maps[mapId], 'dataLayersHistory', []);
    },

    setDataLayerHistoryIndex(state, { mapId, index }) {
      Vue.set(state.maps[mapId], 'dataLayersHistoryIndex', index);
    },
  },
  getters: {
    /**
     * Devuelve elementos del mapa
     * @param {any} state
     */
    getMap: (state) => (mapId) => {
      return state.maps[mapId]?.map;
    },

    getMarkers: (state) => (mapId) => {
      return state.maps[mapId]?.markers;
    },

    getCircles: (state) => (mapId) => {
      return state.maps[mapId]?.circles;
    },

    getPolygons: (state) => (mapId) => {
      return state.maps[mapId]?.polygons;
    },

    getDataLayers: (state) => (mapId) => {
      return state.maps[mapId]?.dataLayers;
    },

    getDrawingMode: (state) => (mapId) => {
      return state.maps[mapId]?.drawingMode;
    },

    getMapStyle: (state) => (mapId) => {
      return state.maps[mapId]?.mapStyle;
    },

    getMapSettings: (state) => (mapId) => {
      return state.maps[mapId]?.mapSettings;
    },

    getZoom: (state) => (mapId) => {
      return state.maps[mapId]?.zoom;
    },

    getCenter: (state) => (mapId) => {
      return state.maps[mapId]?.center;
    },

    getActiveMarker: (state) => (mapId) => {
      return state.maps[mapId]?.activeMarker;
    },

    getJumpingMarker: (state) => (mapId) => {
      return state.maps[mapId]?.jumpingMarker;
    },

    getSelectedMarkerInfo: (state) => (mapId) => {
      return state.maps[mapId]?.selectedMarkerInfo;
    },

    getDefaultPolygonStyle: (state) => {
      return state.defaultPolygonStyle;
    },

    getDefaultCircleStyle: (state) => {
      return state.defaultCircleStyle;
    },

    getDefaultDataLayerStyle: (state) => {
      return state.defaultDataLayerStyle;
    },

    getResetDataLayers: (state) => (mapId) => {
      return state.maps[mapId]?.resetDataLayer;
    },

    getDataLayersHistory: (state) => (mapId) => {
      return state.maps[mapId]?.dataLayersHistory;
    },

    getDataLayersHistoryIndex: (state) => (mapId) => {
      return state.maps[mapId]?.dataLayersHistoryIndex;
    },

    getIsEditableMap: (state) => (mapId) => {
      return !!state.maps[mapId]?.resetDataLayer;
    },
  },
};
export default pixMapModule;
